<script setup lang="ts">
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import DateInput from '@/corePagesModule/components/DateInput.vue';
const t = i18n.t;

const props = defineProps<{ modalState: boolean; selectedCount: number }>();
const emits = defineEmits<{ (e: 'next', eta: number | null); (e: 'close') }>();

const eta = ref<number>(0);

watch(
  () => props.modalState,
  () => (eta.value = 0)
);
</script>
<template>
  <InfoModal
    :modal-state="props.modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('変更')"
    :is-disabled-next-button="!eta"
    @on-next="emits('next', eta)"
    @on-back="emits('close')"
  >
    <template #title>
      {{ t('納期の一括変更') }}
    </template>
    <template #description>
      {{ t('変更後の納期を入力してください') }}
    </template>
    <template #default>
      <div class="info">
        <div class="info__label">{{ t('選択されている発注') }}</div>
        <div class="info__value">
          <span class="info__value--num">{{ selectedCount }}</span>
          {{ t('件') }}
        </div>
      </div>
      <div class="date-input__container">
        <div class="date-input">
          <DateInput :model-value="eta" display-icon text-centering auto-apply @update:model-value="eta = $event" />
        </div>
      </div>
    </template>
  </InfoModal>
</template>
<style lang="scss" scoped>
.info {
  display: grid;
  padding: 0 32px;
  gap: 8px;
  grid-template-columns: max-content max-content;
  align-items: center;
  justify-content: center;
  &__label {
    font-weight: 700;
    font-size: 16px;
  }
  &__value {
    &--num {
      color: $textDefault;
      font-size: 32px;
      font-weight: 700;
    }
  }
}
.date-input {
  border: 2px solid $borderDefault;
  border-radius: 4px;
  &__container {
    display: grid;
    grid-template-columns: 0.5fr;
    justify-content: center;
  }
}
</style>
